import { useCallback } from 'react'

import { useCrudSelection, useEditingStateWithCtx } from '@/atoms'

export function useActions() {
  const { editing, setEditing } = useEditingStateWithCtx('depot')
  const [selection, setSelection] = useCrudSelection('depots')

  const onCreate = useCallback(() => {
    setSelection('reset')
    setEditing([...selection])
  }, [setEditing, setSelection, selection])

  return { editing, onCreate }
}
